import React from "react";
import { Helmet } from "react-helmet";

type Props = {
    script: string,
    noscript: string,
}

export default function PixelGoogle({script, noscript}: Props) {
    
    return (
        <div>
            <Helmet>
                <script>
                    {`
                        ${script}
                    `}
                </script>
                <noscript>
                    {
                        `
                        ${noscript}
                        `
                    }
                </noscript>
            </Helmet>
        </div>
    )
}